import Company from '@/domain/models/Company';
import DatabaseConnectionsConfigurationList from '@/domain/models/integrator/DatabaseConnectionsConfigurationList';
import TableConfigurations from '@/domain/models/integrator/TableConfigurations';
import IIntegratorTablesConfig from '@/views/integratorConfig/interfaces/forms/IIntegratorTablesConfig';
import IIntegratorDatabsaeConnectionsDataToUpdate from '@/views/integratorConfig/interfaces/stores/IIntegratorDatabsaeConnectionsDataToUpdate';
import IIntegratorTablesDataToUpdate from '@/views/integratorConfig/interfaces/stores/IIntegratorTablesDataToUpdate';

export default {
  namespaced: true,
  state: {
    companies: [],
    selectedDataToUpdate: {
      companyId: NaN,
      table: '',
    },
    tableFilesData: [],
    lastUpsertComponentOpened: undefined,
    databaseAliasToUpdate: undefined,
  },
  mutations: {
    setCompanies(state: any, companies: Company[]) {
      state.companies = companies;
    },
    setDataToUpdate(state: any, data: IIntegratorTablesDataToUpdate) {
      state.selectedDataToUpdate = {
        companyId: data.companyId,
        table: data.table,
      };
    },
    setTableFilesData(state: any, tablesData: TableConfigurations[]) {
      state.tableFilesData = tablesData;
    },
    setLastUpsertComponentOpened(state: any, componentName: string|undefined) {
      state.lastUpsertComponentOpened = componentName;

      console.log(componentName);
    },
    setDatabaseAliasToUpdate(state: any, databaseAlias: string|undefined) {
      state.databaseAliasToUpdate = databaseAlias;
    },
  },
  getters: {
    getSpecificTableFromTablesList: (state: any) => (tableName: string) => state.tableFilesData
        .find((table: TableConfigurations) => table.tableName === tableName),
    getSpecificTableCompanyFromTablesList: (state: any) => (
      filter: IIntegratorTablesDataToUpdate,
    ) => {
      const foundedTable = state.tableFilesData
        .find((table: TableConfigurations) => table.tableName === filter.table);

      if (!foundedTable) {
        return null;
      }

      return foundedTable.tablesByCompanies.find(
        (tableCompanyData: IIntegratorTablesConfig) => (
          tableCompanyData.companyId === filter.companyId
        ),
      );
    },
  },
};
